import { ThemeContent } from './types';
import partA from './sm/part-a';
import partB from './sm/part-b';
import partC from './sm/part-c';

// Thema Social media — samengesteld uit drie deelbestanden (modules 0-2, 3-5, 6-8).
const sm: ThemeContent = { ...partA, ...partB, ...partC };

export default sm;
